import { jsx as m, jsxs as b } from "react/jsx-runtime";
import p, { createContext as we, useContext as Se, useCallback as w, useMemo as C, useRef as T, useReducer as H, useEffect as k, useState as O } from "react";
import { useHistory as W, useLocation as M, useRouteMatch as Xe, Route as U, Redirect as Ye, Switch as B } from "react-router-dom";
import Ze from "lodash/omit";
import q from "tiny-invariant";
import ke from "lodash/first";
import ve from "lodash/isEqual";
import et from "lodash/last";
import { guard as tt, interpret as Ee, createMachine as G, transition as y, state as j, action as P, reduce as rt } from "robot3";
import * as z from "query-string";
import Re, { stringify as nt, parse as se } from "query-string";
import K, { isCancel as ot } from "axios";
import Q from "lodash/camelCase";
import st from "lodash/isObject";
import it from "lodash/snakeCase";
import { parseISO as at, format as ct, formatRFC7231 as ut } from "date-fns";
import { datadogLogs as ie } from "@datadog/browser-logs";
import { datadogRum as $ } from "@datadog/browser-rum";
import { Application as lt } from "stimulus";
import { Replay as dt, init as ft, configureScope as pt } from "@sentry/browser";
import { BrowserTracing as mt } from "@sentry/tracing";
import ht from "numeral";
import yt from "lodash/upperFirst";
import { Key as be } from "w3c-keys";
import ae from "js-cookie";
import { useMutation as gt, useQuery as wt } from "@apollo/client";
import { useSuspenseQuery as jn } from "@apollo/client";
import { Kind as St, OperationTypeNode as kt } from "graphql";
import vt from "lodash/merge";
import { v4 as x } from "uuid";
import Et from "lodash/flatten";
import Rt from "lodash/zip";
import bt from "lodash/pick";
const J = we(
  void 0
), Tt = (e, t) => e.includes(t) ? (e.indexOf(t) + 1) / e.length * 100 : 0;
function X() {
  const e = Se(J);
  q(e, "useFlowState must be used within a FlowStateProvider.");
  const { flow: t, basePath: r } = e, n = w(
    (u) => {
      t.send({ type: u });
    },
    [t]
  ), o = w(
    (u) => {
      t.send({ type: "updateValues", values: u });
    },
    [t]
  ), s = w(
    (u, d) => {
      q(
        e.steps.includes(u),
        `unknown step: "${u}". Must be one of ${e.steps.map((h) => `"${h}"`).join(", ")} `
      ), d && o(d), t.send({ type: u, basePath: r });
    },
    [t, e.steps, o, r]
  ), i = w(
    (u = {}) => {
      t.send({ type: "next", values: u, basePath: r });
    },
    [t, r]
  ), c = w(() => {
    t.send({ type: "previous", basePath: r });
  }, [t, r]), a = (u) => () => {
    const d = t.machine.state.value.transitions.get(u);
    if (d)
      return d[0].to;
  }, l = Tt(
    e.steps,
    e.currentStep
  );
  return {
    flowState: Ze(e, ["flow"]),
    sync: n,
    updateValues: o,
    progressPercent: l,
    goToStep: s,
    goToNextStep: i,
    goToPreviousStep: c,
    getNextStep: a("next"),
    getPreviousStep: a("previous")
  };
}
function Y({
  children: e,
  component: t,
  name: r
}) {
  const n = W(), o = M(), s = Xe(), i = X(), { basePath: c } = i.flowState, a = {
    history: n,
    location: o,
    match: s,
    ...i
  };
  let l = typeof e == "function" ? e(a) : e;
  return t && (l = /* @__PURE__ */ m(t, { ...a })), /* @__PURE__ */ m(U, { path: `${c}/${r}`, children: l });
}
const Z = (e, t) => {
  var r;
  return ((r = e.split(t || "/").pop()) == null ? void 0 : r.replace("/", "")) || "";
}, A = () => rt((e, t) => ({
  ...e,
  ...t.values
})), on = (e) => tt(e), ce = (e, ...t) => y("next", e, ...t, A()), ue = (e, ...t) => y("previous", e, ...t), xt = (e) => ({
  [e]: [y("updateValues", e, A())]
}), At = (e, t, r) => {
  const n = e.map((s) => Object.keys(s)[0]), o = n.reduce((s, i, c) => {
    const a = [
      ...e[c][i],
      ...n.map((l) => y(l, l)),
      y("reset", ke(n))
    ];
    return {
      ...s,
      [i]: j(...a)
    };
  }, {});
  return G(
    r || Object.keys(o)[0],
    o,
    (s) => s ? { ...t, ...s } : t
  );
}, le = (e, t) => {
  const [r, ...n] = typeof e == "string" ? [e] : e;
  return t(
    r,
    ...n
  );
}, It = (e, t, r) => {
  const n = Object.keys(e), o = n.map((s) => {
    const i = xt(s);
    let { next: c, previous: a } = e[s];
    return c ? (typeof c == "string" && (c = [c]), i[s].push(
      ...c.map(
        (l) => le(l, ce)
      )
    )) : c !== !1 && s !== et(n) && i[s].push(ce(n[n.indexOf(s) + 1])), a ? (typeof a == "string" && (a = [a]), i[s].push(
      ...a.map(
        (l) => le(l, ue)
      )
    )) : a !== !1 && s !== ke(n) && i[s].push(ue(n[n.indexOf(s) - 1])), i;
  });
  return At(o, t, r);
};
function N(e) {
  return (t, r) => {
    e == null || e(r.values);
  };
}
function Te(e, t) {
  switch (t.type) {
    case "UPDATE":
      return {
        ...e,
        currentState: t.nextState,
        context: t.nextContext
      };
    default:
      return e;
  }
}
const Ct = (e, t, r, n) => {
  const [{ currentState: o, context: s }, i] = H(
    (l, u) => Te(l, u),
    {
      currentState: "ready",
      context: e
    }
  ), c = G(
    {
      ready: j(
        y(
          "next",
          "finished",
          A(),
          P(N(t))
        ),
        y(
          "previous",
          "finished",
          P(N(r))
        ),
        y(
          "updateValues",
          "ready",
          A(),
          P(N(n))
        )
      ),
      finished: j()
    },
    (l) => l ? { ...e, ...s } : e
  ), a = Ee(
    c,
    (l) => {
      i({
        type: "UPDATE",
        nextState: l.machine.current,
        nextContext: l.context
      });
    },
    e
  );
  return { currentState: o, context: s, flowService: a };
}, Ot = (e, t) => {
  const r = W(), { location: n } = r, o = C(() => r.push.bind(r), [r]), s = T(e), i = T(
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    u(s.current, s.current.context)
  ), [{ currentState: c, context: a }, l] = H(
    (d, h) => Te(d, h),
    {
      currentState: i.current.machine.current,
      context: i.current.context
    }
  );
  k(() => {
    if (!ve(
      Object.keys(s.current.states),
      Object.keys(e.states)
    )) {
      s.current = e;
      const d = u(e, i.current.context);
      i.current = d;
    }
  }, [e]), k(() => {
    Z(n.pathname, t) !== c && r.action === "PUSH" && o(`${t}/${c}`), r.action !== "PUSH" && (r.action = "PUSH");
  }, [c, t, o]);
  function u(d, h) {
    try {
      return Ee(
        d,
        (f) => {
          i.current.machine.current !== f.machine.current && (i.current.machine = G(
            f.machine.current,
            s.current.states,
            () => f.context
          )), l({
            type: "UPDATE",
            nextState: f.machine.current,
            nextContext: f.context
          });
        },
        h || {}
      );
    } catch (f) {
      throw f instanceof Error && f.name === "TypeError" && f.message.includes("enter") ? new Error("Current step is unknown to this flow") : f;
    }
  }
  return [c, a, i.current];
}, E = ({
  to: e,
  preserveQueryParams: t = !0,
  ...r
}) => {
  let { search: n } = M();
  if (t) {
    if (typeof e == "string")
      if (e.includes("?")) {
        const [o, s] = e.split("?");
        e = { pathname: o }, n = nt(
          { ...se(n), ...se(s) },
          { sort: !1 }
        );
      } else
        e = {
          pathname: e
        };
    e = { ...e, search: n };
  }
  return /* @__PURE__ */ m(Ye, { to: e, ...r });
};
function Mt({
  children: e,
  onNextStep: t,
  onPreviousStep: r,
  onUpdateValues: n,
  initialValues: o = {}
}) {
  const {
    currentState: s,
    context: i,
    flowService: c
  } = Ct(
    o,
    t,
    r,
    n
  ), a = {
    basePath: "",
    currentStep: s,
    flow: c,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    steps: ["ready", "finished"],
    returnToPath: "/",
    values: i
  }, u = p.Children.toArray(e)[0];
  if ((u == null ? void 0 : u.type) === Y) {
    const d = u.props.name;
    return /* @__PURE__ */ b(J.Provider, { value: a, children: [
      e,
      /* @__PURE__ */ m(B, { children: /* @__PURE__ */ m(E, { from: "/", to: `/${d}`, exact: !0 }) })
    ] });
  }
  throw new Error("Can only have a single step child");
}
function _t({
  children: e,
  component: t,
  onUpdateValues: r,
  onNextStep: n,
  onPreviousStep: o,
  initialValues: s = {}
}) {
  return /* @__PURE__ */ m(
    Mt,
    {
      onUpdateValues: r,
      onNextStep: n,
      onPreviousStep: o,
      initialValues: s,
      children: /* @__PURE__ */ m(Y, { name: "ready", component: t, children: e })
    }
  );
}
const sn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IsolatedStep: _t
}, Symbol.toStringTag, { value: "Module" })), Lt = () => {
  const e = document.querySelector(
    'meta[name="csrf-token"]'
  );
  return e ? e.content : null;
};
function ee(e, t) {
  const r = p.useRef();
  return (!r.current || !ve(t, r.current.key)) && (r.current = { key: t, value: e() }), r.current.value;
}
function I(e, t) {
  return Array.isArray(e) ? e.map((r) => I(r, t)) : st(e) ? Object.keys(e).reduce(
    (r, n) => ({
      ...r,
      [t(n)]: I(e[n], t)
    }),
    {}
  ) : e;
}
const xe = (e) => e ? I(e, (t) => Q(t)) : null, V = (e) => e ? I(e, (t) => it(t)) : null, Ae = {
  messages: { base: ["Looks like something went wrong"] },
  status: 503
}, Pt = [200, 201, 422, 401];
async function $t(e, t) {
  const { status: r } = e;
  let n;
  return "cancelled" in e ? { data: void 0, meta: void 0, errors: void 0 } : r === 204 ? { data: {} } : r === 404 ? {
    errors: {
      messages: { base: ["Looks like something went wrong"] },
      status: r
    }
  } : r === 503 ? { errors: Ae } : Pt.includes(r) ? (r === 422 ? (n = await t(e), n = {
    data: n.data,
    errors: { messages: n.errors, status: r },
    meta: n.meta
  }) : n = await t(e), xe(n)) : {
    errors: {
      messages: { base: ["Looks like something went wrong"] },
      status: r
    }
  };
}
function an(e) {
  return e ? e.status === 404 : !1;
}
function cn(e) {
  return e ? e.status === Ae.status : !1;
}
const Ie = K.create({
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json"
  },
  withCredentials: !0
});
Ie.interceptors.request.use((e) => (e.headers["X-CSRF-Token"] = Lt(), e));
const te = p.createContext(
  null
), un = ({ client: e = Ie, children: t }) => (
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  /* @__PURE__ */ m(te.Provider, { value: { client: e }, children: t })
);
function Ce(e, [t, r]) {
  switch (t) {
    case 0:
      return {
        ...e,
        loading: !0,
        errors: null,
        networkError: null
      };
    case 1:
      return {
        ...e,
        loading: !1,
        ...r
      };
    case 2:
      return {
        ...e,
        loading: !1,
        networkError: r
      };
    case 3:
      return {
        ...e,
        loading: !1
      };
    default:
      return e;
  }
}
async function Oe(e, t, r, n) {
  if (!n.url)
    throw new Error("url required!");
  e([
    0
    /* START */
  ]);
  let o;
  try {
    o = await r(n);
  } catch (i) {
    if (ot(i))
      o = {
        cancelled: !0,
        data: null,
        status: 0,
        statusText: "Cancelled",
        headers: {},
        config: n
      };
    else if (i.response)
      o = i.response;
    else
      throw t.current && e([2, i]), i;
  }
  const s = await $t(o, ({ data: i }) => Promise.resolve(i || {}));
  return t.current && ("cancelled" in o ? e([
    3
    /* CANCEL */
  ]) : e([1, s])), s;
}
function ln(e, t = { qs: null, skip: !1 }) {
  const r = p.useContext(te);
  if (!r)
    throw new Error("Must be under DataFetchProvider");
  const { client: n } = r, { qs: o, skip: s } = t, i = ee(() => o, o), c = p.useRef(!0), [a, l] = p.useReducer(Ce, {
    loading: !s,
    data: null,
    meta: null,
    errors: null,
    networkError: null
  }), u = p.useRef(), d = p.useCallback(
    (f) => {
      var g;
      return (g = u.current) == null ? void 0 : g.cancel(f);
    },
    [u]
  ), h = p.useCallback(
    (f = {}) => (u.current = K.CancelToken.source(), Oe(l, c, n, {
      url: e,
      params: V(f.qs || i),
      cancelToken: u.current.token
    })),
    [e, i, n, u]
  );
  return p.useEffect(() => (c.current = !0, s || h(), () => {
    c.current = !1, d("Request was automatically cancelled");
  }), [h, s, d]), { ...a, refetch: h, cancel: d };
}
function dn(e, t = { qs: null, method: "post" }) {
  const r = p.useContext(te);
  if (!r)
    throw new Error("Must be under DataFetchProvider");
  const { client: n } = r, { qs: o, method: s } = t, i = p.useRef(!0), c = ee(() => o, o), [a, l] = p.useReducer(Ce, {
    loading: !1,
    data: null,
    meta: null,
    errors: null,
    networkError: null
  }), u = p.useRef(), d = p.useCallback(
    (f) => {
      var g;
      return (g = u.current) == null ? void 0 : g.cancel(f);
    },
    [u]
  ), h = p.useCallback(
    (f) => (u.current = K.CancelToken.source(), Oe(l, i, n, {
      url: e,
      method: s,
      params: V(c),
      data: V(f),
      cancelToken: u.current.token
    })),
    [e, c, s, n, u]
  );
  return p.useEffect(() => () => {
    i.current = !1, d("Request was automatically cancelled");
  }, [d]), [h, { ...a, cancel: d }];
}
var Me = /* @__PURE__ */ ((e) => (e.iso8601 = "yyyy-MM-dd", e.longOrdinal = "MMMM d, yyyy", e.longOrdinalShortMonth = "MMM d, yyyy", e.longOrdinalSlashed = "MM/dd/yyyy", e.longOrdinalSlashedNonPadded = "M/d/yyyy", e.longOrdinalWithDay = "EEEE, MMMM dd, yyyy", e.longOrdinalWithTimeAndZone = "MMMM dd, yyyy h:mma xxxxx", e.month = "MMMM", e.shortOrdinal = "MMMM d", e.shortOrdinalShortMonth = "MMM d", e))(Me || {});
const fn = (e, t = "longOrdinal") => (typeof e == "string" && (e = at(e)), ct(e, Me[t]));
class Nt {
  constructor(t) {
    this.config = t, this.datadogLogs = ie, this.datadogRum = $;
  }
  initialize() {
    var t, r;
    (t = this.config) != null && t.isRumEnabled && ($.init({
      applicationId: this.config.applicationId,
      clientToken: this.config.clientToken,
      site: this.config.site,
      service: this.config.service,
      env: this.config.env || "production",
      sessionSampleRate: this.config.sampleRate ?? 100,
      sessionReplaySampleRate: this.config.replaySampleRate ?? 0,
      trackResources: !0,
      trackLongTasks: !0,
      trackUserInteractions: !0,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: this.config.allowedTracingUrls
    }), $.startSessionReplayRecording()), (r = this.config) != null && r.isLoggingEnabled && ie.init({
      clientToken: this.config.clientToken,
      site: "datadoghq.com",
      forwardErrorsToLogs: !0,
      sessionSampleRate: this.config.logSampleRate ?? 100,
      service: this.config.service,
      env: this.config.env
    });
  }
}
class Dt {
  constructor(t) {
    this.config = t;
  }
  initialize() {
    const t = [new mt()];
    this.config.isReplayEnabled && t.push(
      // @ts-expect-error production types from Sentry are mismatched
      new dt({
        blockAllMedia: !1
      })
    ), ft({
      dsn: this.config.sentryApiToken,
      environment: this.config.sentryEnvironment,
      beforeSend: this.config.beforeSend,
      beforeBreadcrumb: this.excludeMiniProfiler.bind(this),
      release: this.config.sentryRelease,
      allowUrls: this.config.sentryWhitelistUrls,
      denyUrls: this.config.sentryDisallowListUrls ?? [],
      integrations: t,
      tracesSampleRate: this.config.sentryTracesSampleRate ?? 0.2,
      replaysSessionSampleRate: this.config.sentrySessionReplaySampleRate ?? 0,
      replaysOnErrorSampleRate: this.config.sentryErrorReplaySampleRate ?? 0.25,
      tracePropagationTargets: this.config.sentryTracePropagationTargets
    }), pt((r) => {
      const {
        plan_manager_id: n,
        id: o,
        retail_user_id: s
      } = this.config.user;
      n ? r.setUser({ plan_manager_id: n }) : r.setUser({ id: o, retail_user_id: s });
    });
  }
  excludeMiniProfiler(t) {
    return t.category === "xhr" && t.data && t.data.url === "/mini-profiler-resources/results" ? null : t;
  }
}
class pn {
  constructor(t, r, n) {
    this.definitions = t, this.sentryAppConfig = r, this.dataDogConfig = n, this.sentryInitializer = new Dt(this.sentryAppConfig), this.dataDogInitializer = this.dataDogConfig ? new Nt(this.dataDogConfig) : void 0;
  }
  initialize() {
    const t = lt.start();
    return this.sentryAppConfig.sentryApiToken && this.sentryInitializer.initialize(), this.dataDogInitializer && this.dataDogInitializer.initialize(), this.loadApplication(t);
  }
  async loadApplication(t) {
    return await this.domReady(), t.load(this.definitions), t;
  }
  domReady() {
    return new Promise((t) => {
      document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => t()) : t();
    });
  }
}
var _e = /* @__PURE__ */ ((e) => (e.credit = "+$0,0.00", e.debit = "-$0,0.00", e.default = "$0,0.00", e.creditOptional = "+$0,0[.]00", e.debitOptional = "-$0,0[.]00", e.defaultOptional = "$0,0[.]00", e.creditDollar = "+$0,0", e.debitDollar = "-$0,0", e.defaultDollar = "$0,0", e))(_e || {});
class Ut {
  constructor(t) {
    this.cents = Number(t.toFixed(0));
  }
  get dollars() {
    return this.cents / 100;
  }
}
const mn = (e) => new Ut(e), hn = (e) => Math.round(parseFloat(e) * 100) * 1e4 / 1e4, yn = (e, t = "default") => {
  let { dollars: r } = e;
  return /^debit/.exec(t) && (r = -Math.abs(r)), ht(r).format(_e[t]);
}, qt = {
  atLeastSmall: "(min-width: 500px)",
  atLeastMedium: "(min-width: 700px)",
  atLeastLarge: "(min-width: 964px)",
  atLeastExtraLarge: "(min-width: 1224px)"
};
function gn(e) {
  const t = qt[e], r = C(() => window.matchMedia(t), [t]), [n, o] = O(r.matches);
  return k(() => {
    const s = ({ matches: i }) => o(i);
    return r.addListener(s), () => {
      r.removeListener(s);
    };
  }, [r, t]), n;
}
const jt = (e) => e.key === be.Enter, zt = (e) => e.tagName.toLowerCase() === "button" || e.getAttribute("role") === "button", Vt = (e) => e.key === be.Space, Ft = (e, t) => Vt(t) && zt(e), Ht = (e, t) => jt(t) || Ft(e, t), Wt = [
  /\.bettermentforadvisors.com$/,
  /\.betterment\.com$/,
  /\.betterment\.io$/,
  /\.betterment\.qa$/,
  /^bettermentforadvisors\.com$/,
  /^betterment\.com$/,
  /^betterment\.io$/,
  /^betterment\.qa$/,
  /test$/,
  /^localhost$/
], Le = (e) => {
  const t = /\/(?!401k)[0-9]+/g, r = /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g;
  return e.replace(r, "/_").replace(t, "/_");
}, Bt = () => Le(window.location.pathname), Pe = () => {
  const { token: e, ...t } = z.parse(window.location.search);
  return e ? z.stringify({ token: "_", ...t }) : window.location.search;
}, Gt = () => {
  const e = Pe();
  return `${window.location.origin}${Le(window.location.pathname)}${e ? `?${e}` : ""}`;
}, Kt = (e) => e.endsWith("/") ? e.replace(/\/+$/, "") : e;
function Qt(e) {
  try {
    const t = new URL(e);
    return ["http:", "https:"].find(
      (o) => t.protocol === o
    ) ? Wt.find(
      (o) => RegExp(o).exec(t.hostname)
    ) : !1;
  } catch {
    return !0;
  }
}
function $e(e, t = "") {
  if (!e)
    return t;
  const r = /[^\x20-\x7EÀ-ž]/gim, n = /[\<\>\"\'\%\;\(\)]/g, o = decodeURI(e).replace(r, "").replace(n, "").trim();
  return Qt(o) ? o : t;
}
function Ne(e) {
  const { search: t } = M(), r = xe(z.parse(t)) || {};
  return O(() => e != null && e.parseArrays ? r : Object.keys(r).reduce((n, o) => {
    const s = r[o];
    return {
      ...n,
      [o]: Array.isArray(s) ? s[0] : s
    };
  }, {}))[0];
}
const Jt = (e = "") => {
  const { returnTo: t } = Ne();
  return $e(t, e);
}, wn = (e = "") => {
  const { exitTo: t } = Ne();
  return $e(t, e);
}, S = () => window.analytics, Xt = '[data-track-event="ElementClicked"], [data-track-event="AppStoreSelected"]', Yt = '[data-track-event="ElementHovered"]', Zt = '[data-track-event="ElementViewed"]', de = "data-hover-listener-registered", fe = "data-view-listener-registered", pe = "data-interaction-listener-registered", v = "true", er = 3e3;
let De, Ue;
const re = new Promise((e) => {
  Ue = e;
}), tr = () => {
  const e = window.navigator.userAgent;
  return /Android.*Betterment/.test(e) ? "AndroidWebView" : /Android/.test(e) ? "AndroidMobileWeb" : /(iPhone|iPod|iPad).*Safari/.test(e) ? "iOSMobileWeb" : /(iPhone|iPod|iPad)/.test(e) ? "iOSWebView" : "Web";
}, qe = (e) => {
  const t = e.getAttribute("data-track-name"), r = e.textContent || void 0;
  return {
    name: t || yt(Q(r)),
    flow: e.getAttribute("data-track-flow"),
    module: e.getAttribute("data-track-module"),
    location: e.getAttribute("data-track-location")
  };
}, je = () => ({
  application: De,
  client: tr(),
  path: Bt(),
  search: Pe(),
  url: Gt()
}), ze = (e, t, r) => {
  const n = { ...je(), ...t };
  re.then(() => {
    S().track(e, n, r);
  });
}, Ve = (e, t) => {
  const r = e.getAttribute("data-track-event");
  if (r === "ElementClicked" || r === "AppStoreSelected") {
    const n = { ...qe(e), interaction: t };
    ze(r, n);
  }
}, rr = (e, t) => {
  Ht(e, t) && Ve(e, "keydown");
}, Fe = (e) => {
  const t = e.getAttribute("data-track-event");
  if (t === "ElementHovered" || t === "ElementViewed") {
    const r = { ...qe(e) };
    ze(t, r);
  }
}, nr = () => window._DATADOG_SYNTHETICS_BROWSER === void 0, or = () => {
  [].slice.call(
    document.querySelectorAll(Xt)
  ).forEach((t) => {
    t.getAttribute(pe) !== v && (t.addEventListener(
      "click",
      () => Ve(t, "click")
    ), t.addEventListener(
      "keydown",
      (r) => rr(t, r)
    ), t.setAttribute(
      pe,
      v
    ));
  });
}, sr = () => {
  [].slice.call(
    document.querySelectorAll(Zt)
  ).forEach((t) => {
    if (t.getAttribute(fe) !== v) {
      const r = new IntersectionObserver(
        (n) => {
          n.every((o) => o.isIntersecting) && (r.unobserve(t), Fe(t));
        },
        { threshold: 1 }
      );
      r.observe(t), t.setAttribute(
        fe,
        v
      );
    }
  });
}, ir = () => {
  [].slice.call(
    document.querySelectorAll(Yt)
  ).forEach((t) => {
    t.getAttribute(de) !== v && (t.addEventListener("mouseenter", () => Fe(t), {
      once: !0
    }), t.setAttribute(
      de,
      v
    ));
  });
}, ne = () => {
  or(), ir(), sr();
}, He = (e = {}) => {
  re.then(() => {
    S().page({ ...je(), ...e });
  });
}, me = async () => {
  const e = new Promise((r) => {
    const n = () => {
      document.removeEventListener("turbolinks:load", n), r();
    };
    document.addEventListener("turbolinks:load", n);
  }), t = new Promise((r) => {
    setTimeout(r, er);
  });
  He(), await Promise.race([t, e]), ne();
}, ar = () => {
  const e = window.history.pushState.bind(window.history), t = window.history.replaceState.bind(window.history);
  window.history.pushState = function(n, o, s) {
    return me(), e.apply(this, [n, o, s]);
  }, window.history.replaceState = function(n, o, s) {
    return me(), t.apply(this, [n, o, s]);
  };
}, cr = new MutationObserver(() => {
  ne();
}), Sn = (e, t, r) => {
  De = t, S().ready(() => {
    S().user().id() !== e && S().identify(e), nr() && Ue(!0), He(r), ar(), ne(), cr.observe(document, {
      childList: !0,
      subtree: !0
    });
  });
};
function kn(e) {
  re.then(() => {
    S().identify(void 0, e);
  });
}
function ur(e) {
  var t = window.analytics = window.analytics || [];
  if (!t.initialize) {
    if (t.invoked) {
      window.console && console.error && console.error("Segment snippet included twice.");
      return;
    }
    t.invoked = !0, t.methods = [
      "trackSubmit",
      "trackClick",
      "trackLink",
      "trackForm",
      "pageview",
      "identify",
      "reset",
      "group",
      "track",
      "ready",
      "alias",
      "debug",
      "page",
      "once",
      "off",
      "on"
    ], t.factory = function(o) {
      return function() {
        var s = Array.prototype.slice.call(arguments);
        return s.unshift(o), t.push(s), t;
      };
    };
    for (var r = 0; r < t.methods.length; r++) {
      var n = t.methods[r];
      t[n] = t.factory(n);
    }
    t.load = function(o, s) {
      var i = document.createElement("script");
      i.type = "text/javascript", i.async = !0, i.src = "https://cdn.segment.com/analytics.js/v1/" + o + "/analytics.min.js";
      var c = document.getElementsByTagName("script")[0];
      c.parentNode.insertBefore(i, c), t._loadOptions = s;
    }, t.SNIPPET_VERSION = "4.1.0", t.load(e);
  }
}
const vn = (e) => {
  ur(e);
}, he = Object.freeze([
  "accountNumber",
  "addGoalCustomImageData",
  "address",
  "address1",
  "address2",
  "answer",
  "cashflowCategory",
  "cashflowSubcategory",
  "city",
  "confirmPassword",
  "customImageData",
  "dateOfBirth",
  "dobYear",
  "dobMonth",
  "documentContent",
  "email",
  "employer",
  "encodedFile",
  "federalTaxIdNumber",
  "firstName",
  "lastName",
  "legalName",
  "memo",
  "nickname",
  "password",
  "performerPassword",
  "question",
  "phone",
  "phoneNumber",
  "proofOfAddress",
  "routingNumber",
  "secondaryDocument",
  "secret",
  "securityAnswer1",
  "securityAnswer2",
  "socialSecurityNumber",
  "ssn",
  "taxId",
  "taxpayerIdentificationNumber",
  "usGovId",
  "userName",
  "zip",
  "zipCode"
]), lr = (e, t, { ttl: r = 600 } = {}) => {
  q(
    !Object.keys(t || {}).some(
      (l) => he.includes(Q(l))
    ),
    `Stored values must not be one of the following: ${he.join(
      ", "
    )}`
  );
  const n = Number(/* @__PURE__ */ new Date()) + r * 1e3, o = `bmt.${e}`;
  t && !sessionStorage.getItem(o) && sessionStorage.setItem(
    o,
    JSON.stringify({ expiry: n, value: t })
  );
  const s = sessionStorage.getItem(o), i = C(() => {
    if (s) {
      const { expiry: l, value: u } = JSON.parse(s);
      if (Date.now() < l)
        return u;
    }
    return null;
  }, [s]), c = w(
    (l) => {
      sessionStorage.setItem(
        o,
        JSON.stringify({
          expiry: n,
          value: l
        })
      );
    },
    [o, n]
  ), a = w(() => {
    sessionStorage.removeItem(o);
  }, [o]);
  return { values: i, saveValues: c, clearValues: a };
};
function En({
  sessionKey: e,
  safeFields: t
}) {
  const { saveValues: r } = lr(e), { flowState: n } = X(), o = t ? bt(n.values, t) : n.values, s = ee(() => o, o);
  return k(() => {
    r(s);
  }, [r, s]), null;
}
const Rn = ({
  path: e,
  routeElement: t = /* @__PURE__ */ m(U, {}),
  ...r
}) => /* @__PURE__ */ b(B, { children: [
  /* @__PURE__ */ m(E, { from: e, to: `${e}/new`, exact: !0 }),
  /* @__PURE__ */ m(
    U,
    {
      path: `${e}/new`,
      render: () => /* @__PURE__ */ m(E, { to: `${e}/${x()}` })
    }
  ),
  p.cloneElement(t, { ...r, path: `${e}/:id` })
] }), dr = () => {
  const { location: e, action: t } = W(), { sync: r, flowState: n } = X(), o = Z(e.pathname, n.basePath);
  return k(() => {
    t === "POP" && o && r(o);
  }, [t, o, r]), null;
};
function bn({
  basePath: e = "",
  children: t,
  currentStep: r,
  initialValues: n = {},
  defaultStep: o,
  returnToPath: s
}) {
  const i = M(), c = C(
    () => p.Children.toArray(t).reduce(
      (oe, Je) => {
        const R = Je;
        if ((R == null ? void 0 : R.type) === Y) {
          const L = R.props;
          oe[L.name] = {
            next: L.next,
            previous: L.previous
          };
        }
        return oe;
      },
      {}
    ),
    [t]
  ), a = Object.keys(c), l = Jt(s);
  e = Kt(e), o = o || a[0], r = r || Z(i.pathname, e) || o;
  const u = It(
    c,
    n,
    r
  ), [d, h, f] = Ot(u, e), g = {
    basePath: e,
    currentStep: d,
    flow: f,
    steps: a,
    returnToPath: l,
    values: h
  };
  return /* @__PURE__ */ b(J.Provider, { value: g, children: [
    /* @__PURE__ */ m(dr, {}),
    t,
    /* @__PURE__ */ b(B, { children: [
      /* @__PURE__ */ m(
        E,
        {
          from: `${e}/`,
          to: `${e}/${o}`,
          exact: !0
        }
      ),
      e && /* @__PURE__ */ m(
        E,
        {
          from: e,
          to: `${e}/${o}`,
          strict: !0,
          exact: !0
        }
      )
    ] })
  ] });
}
function F(e) {
  return e.replace(/^[/]+/, "").replace(/[/]+$/, "");
}
function We(e, t, r) {
  const n = e === "/", o = `/${t.map(F).join("/")}`, s = (i = {}) => Re.stringifyUrl({
    url: o,
    query: { ...r, ...i }
  });
  return s.path = o, s.absolutePath = n ? o : `${e}${o}`, s.absolute = n ? s : We("/", [e, ...t], r), s;
}
function Be(e, t, r) {
  const n = e === "/", o = `/${t.map((c) => typeof c == "string" ? F(c) : `:${c.param}`).join("/")}`, s = t.filter((c) => typeof c != "string").map(({ param: c }) => c), i = (c) => {
    const a = `/${t.map(
      (u) => typeof u == "string" ? F(u) : c[u.param]
    ).join("/")}`, l = s.reduce(
      (u, d) => ({
        ...u,
        [d]: void 0
      }),
      { ...r, ...c }
    );
    return Re.stringifyUrl({ url: a, query: l });
  };
  return i.path = o, i.absolutePath = n ? o : `${e}${o}`, i.absolute = n ? i : Be("/", [e, ...t], r), i;
}
function Tn(e, t, r = {}) {
  const n = t.filter(
    (o) => typeof o == "string"
  );
  return t.toString() === n.toString() ? We(e, n, r) : Be(e, t, r);
}
function fr(e) {
  return e.reduce(
    (t, { attr: r, direction: n }) => [
      ...t.filter((o) => o.attr !== r),
      { attr: r, direction: n }
    ],
    []
  );
}
const ye = ["number", "string", "bigint", "boolean"];
function D(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function Ge(e, t) {
  const r = e === null ? "null" : typeof e, n = t === null ? "null" : typeof t, o = ye.indexOf(r) !== -1, s = ye.indexOf(n) !== -1;
  return o && !s ? -1 : !o && s ? 1 : o ? r === n ? D(e, t) : D(r, n) : D(e.toString(), t.toString());
}
function pr(e, t, r) {
  const n = t.slice().reverse();
  return r.map((i, c) => ({ item: i, index: c })).sort((i, c) => {
    const a = n.reduce(
      (l, { attr: u, direction: d }) => {
        if (l !== 0)
          return l;
        const f = (e[u] ?? Ge)(i.item[u], c.item[u]);
        return f !== 0 ? d === "asc" ? f : -f : l;
      },
      0
    );
    return a !== 0 ? a : i.index - c.index;
  }).map(({ item: i }) => i);
}
function mr(e) {
  return (t, r) => {
    function n(o) {
      return [...o.filter((s) => s.attr !== t), { attr: t, direction: r }];
    }
    e(n);
  };
}
function hr(e) {
  const t = {};
  return e.forEach(({ attr: r, direction: n }) => {
    t[r] = n;
  }), t;
}
function yr(e, { initialSorts: t = [], compareFunctions: r = {} } = {}) {
  const [n, o] = O(
    () => fr(t)
  );
  return {
    sortBy: mr(o),
    sortState: hr(n),
    activeSorts: n,
    sortedItems: pr(r, n, e)
  };
}
yr.defaultCompare = Ge;
const ge = "bmt_user_states", gr = 365;
class xn {
  constructor(t) {
    this.userId = t, this.cookies = this.getCookies, this.userCookies = this.getUserCookies;
  }
  setStateFor(t, r) {
    this.cookies = this.getCookies, this.userCookies = this.getUserCookies, this.cookies[`user_${this.userId}`] = {
      ...this.userCookies,
      [t]: r
    }, ae.set(ge, this.cookies, { expires: gr });
  }
  getStateFor(t) {
    return this.cookies = this.getCookies, this.userCookies = this.getUserCookies, this.userCookies[t];
  }
  get getCookies() {
    return ae.getJSON(ge) || {};
  }
  get getUserCookies() {
    return this.cookies[`user_${this.userId}`] || {};
  }
}
function wr(e) {
  var r;
  const t = e.definitions.find(
    (n) => n.kind === St.OPERATION_DEFINITION && n.operation === kt.MUTATION
  );
  return (r = t == null ? void 0 : t.name) == null ? void 0 : r.value;
}
function Sr(e, t) {
  return vt(
    {
      context: {
        headers: t
      }
    },
    e
  );
}
const Ke = we({}), kr = (e, t) => {
  const r = t[e];
  if (r === void 0)
    throw new Error(
      `createIdempotencyTokenRegistry was unable to find feature ${e} in the feature registry. Make sure to register your feature in the client's feature-registry.ts.`
    );
  const n = {};
  return Object.entries(r).forEach(
    ([o, { idempotencyToken: s }]) => {
      n[o] = new s();
    }
  ), n;
}, An = ({ children: e, featureName: t, featureRegistry: r }) => {
  const n = T(
    kr(t, r)
  );
  return /* @__PURE__ */ m(Ke.Provider, { value: n.current, children: e });
}, vr = (e) => {
  const r = Se(Ke)[e];
  if (r === void 0)
    throw new Error(
      `useFeatureToken was unable to find feature ${e} in the feature registry. Make sure to register your feature in the client's feature-registry.ts.`
    );
  return r;
}, In = (e, t = {}) => {
  const r = wr(e);
  if (r === void 0)
    throw new Error(
      "useGraphQLMutation was unable to resolve a mutation name in the provided mutation document. Make sure to provide a valid mutation document."
    );
  const n = vr(r), [o, s] = gt(e, t);
  return [(c = {}) => {
    const a = n.prepareHeaders(), l = Sr(
      c,
      a
    ), u = o(l);
    return u.then(() => {
      n.refresh();
    }).catch(() => null), u;
  }, s];
}, Cn = (e, t) => {
  const r = wt(e, t);
  if (((t == null ? void 0 : t.throwOnError) ?? !1) && r.error)
    throw r.error;
  return r;
};
class Qe {
  getKey() {
    return this.key;
  }
  prepareHeaders() {
    return this.firstSent === void 0 && (this.firstSent = ut(/* @__PURE__ */ new Date())), {
      "Idempotency-Key": this.key,
      "Idempotency-First-Sent": this.firstSent
    };
  }
}
class _ extends Qe {
  constructor() {
    super(), this.key = x();
  }
  refresh() {
    this.key = x(), this.firstSent = void 0;
  }
}
class Er extends Qe {
  constructor() {
    super(), this.key = x();
  }
  refresh() {
    return null;
  }
}
class On extends _ {
}
class Mn extends Er {
}
class _n extends _ {
}
class Ln extends _ {
}
class Pn extends _ {
}
var Rr = /* @__PURE__ */ ((e) => (e.IDLE = "idle", e.LOADING = "loading", e.READY = "ready", e.ERROR = "error", e))(Rr || {}), br = /* @__PURE__ */ ((e) => (e.BODY = "body", e.HEAD = "head", e))(br || {});
function $n(e, t) {
  const r = T(null), [n, o] = O(
    e ? "loading" : "idle"
    /* IDLE */
  ), s = (t == null ? void 0 : t.attributes) ?? {}, i = JSON.stringify(s), c = (t == null ? void 0 : t.domNode) ?? "head";
  return k(() => {
    if (!e)
      return o(
        "idle"
        /* IDLE */
      );
    let a = document.querySelector(
      `script[src="${e}"]`
    );
    if (a) {
      const u = a.getAttribute("data-status") ?? "loading";
      o(u);
    } else {
      a = document.createElement("script"), a.src = e, a.setAttribute(
        "data-status",
        "loading"
        /* LOADING */
      );
      const u = JSON.parse(i);
      Object.keys(u).forEach(
        (d) => {
          a.setAttribute(d, u[d]);
        }
      ), a.onerror = () => a == null ? void 0 : a.setAttribute("data-status", "error"), a.onload = () => a == null ? void 0 : a.setAttribute("data-status", "ready"), document[c].appendChild(a);
    }
    const l = (u) => {
      o(
        u.type === "load" ? "ready" : "error"
        /* ERROR */
      );
    };
    return a.addEventListener("load", l), a.addEventListener("error", l), () => {
      a == null || a.removeEventListener("load", l), a == null || a.removeEventListener("error", l), t != null && t.isScriptRemovable && (a == null || a.remove());
    };
  }, [e, c, i]), { status: n, scriptRef: r };
}
function Nn(e) {
  const [t, r] = H(
    (n) => !n,
    e
  );
  return [t, r];
}
function Tr(e, ...t) {
  const r = Et(Rt(e, t)).join(""), n = URL.createObjectURL(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    new Blob([r], { type: "text/javascript" })
  );
  return new Worker(n);
}
function xr(e) {
  return function(r) {
    if (r.data.type === "cacheResponse") {
      const n = Number(/* @__PURE__ */ new Date()), o = Object.keys(r.data.cache).reduce(
        (s, i) => {
          if (i.substring(0, i.indexOf(".")) === "bmt") {
            const c = JSON.parse(r.data.cache[i]);
            return c.expiry && n > c.expiry ? s.concat(i) : s;
          }
          return s;
        },
        []
      );
      e.postMessage({ type: "clearKeys", keys: o });
    }
  };
}
function Dn() {
  const e = Tr`
    self.onmessage = ${xr.toString()}(self)

    var interval = setInterval(function () {
      self.postMessage({ type: 'checkCache' });
    }, 1000 * 60 * 10);

    self.postMessage({ type: 'checkCache' });
  `;
  e.addEventListener("message", ({ data: t }) => {
    if (t.type === "checkCache") {
      const r = Object.keys(sessionStorage).reduce(
        (n, o) => ({ ...n, [o]: sessionStorage.getItem(o) }),
        {}
      );
      e.postMessage({ type: "cacheResponse", cache: r });
    }
    t.type === "clearKeys" && t.keys.forEach((r) => sessionStorage.removeItem(r));
  }), e.onerror = () => {
    throw new Error("Cache worker encountered an error");
  };
}
export {
  Nt as DataDogInitializer,
  un as DataFetchProvider,
  Me as DateFormat,
  On as EditableFormIdempotencyToken,
  Rn as FlowRoute,
  bn as FlowStateProvider,
  Mn as FlowSubmissionIdempotencyToken,
  An as IdempotencyProvider,
  Qe as IdempotencyToken,
  _e as MoneyFormat,
  br as Nodes,
  E as Redirect,
  sn as RuntimeTesting,
  Ae as SERVICE_UNAVAILABLE_ERROR,
  _n as SendEmailIdempotencyToken,
  Dt as SentryInitializer,
  En as SessionSync,
  Rr as Status,
  Y as Step,
  pn as StimulusAppBootstrapper,
  Ln as ToggleIdempotencyToken,
  xn as UserInterfaceState,
  Pn as ValidationIdempotencyToken,
  xe as camelizeKeys,
  xr as createHandler,
  fn as formatDate,
  yn as formatMoney,
  tr as getClient,
  Lt as getCsrfToken,
  Ft as isEligibleSpaceKeydown,
  jt as isEnterKeydown,
  Ht as isKeyboardSelection,
  an as isNotFound,
  cn as isServiceUnavailable,
  Vt as isSpaceKeydown,
  zt as isSpacebarSelectableElement,
  Kt as removeTrailingSlashes,
  Tn as route,
  $e as sanitizeUrlParam,
  Bt as sanitizedPath,
  Pe as sanitizedTokenQuery,
  Gt as sanitizedUrl,
  vn as segmentInitializer,
  kn as setTraits,
  V as snakeizeKeys,
  Sn as startAnalytics,
  Dn as startCacheWorker,
  hn as toCentsFromString,
  mn as toMoney,
  ze as track,
  ee as useDeepMemo,
  wn as useExitToPath,
  vr as useFeatureToken,
  X as useFlowState,
  In as useGraphQLMutation,
  Cn as useGraphQLQuery,
  jn as useGraphQLSuspenseQuery,
  gn as useMatchMedia,
  dn as useMutation,
  ln as useQuery,
  Ne as useQueryParams,
  Jt as useReturnToPath,
  $n as useScript,
  lr as useSessionStorage,
  yr as useSorted,
  Nn as useToggledValue,
  on as when
};
//# sourceMappingURL=js-runtime.mjs.map
